import { Box } from '@mui/material'

export function PageContainer({ children }) {
	return (
		<Box
			sx={{
				mt: '2rem',
				mb: '1rem',
				pl: '5rem',
				pr: '5rem',
				maxWidth: '100%',
				mx: 'auto',
			}}
		>
			{children}
		</Box>
	)
}
